// @ts-check

import {
  addressService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_ADDRESS,
  ADD_ADDRESS,
  REPLACE_ADDRESS,
  SET_USER_VISIBLE_COLUMNS
} from './mutationTypes';
import {
  GET_ADDRESS,
  CREATE_ADDRESS,
  DELETE_ADDRESS,
  UPDATE_ADDRESS,
  GET_USER_VISIBLE_COLUMNS,
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR } from '@/store/helpers';
import { filter, map } from 'lodash';


/** @type {import('vuex').ActionTree<*,*>} */
const actions = {

  
  /**
   * Get all Addresses
   */
  async [GET_ADDRESS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_ADDRESS });      
    commit(SET_ADDRESS, []);
    try {      
      const {
        data: {
          addresses
        }
      }= await addressService.getAddresses(rootState.currentAccountId);
      commit(SET_ADDRESS, addresses);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_ADDRESS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_ADDRESS, error: e });
    }
  },

  /**
   * Create Address
   */
  async [CREATE_ADDRESS]({ rootState, commit }, address) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: CREATE_ADDRESS });
    try {
      const response = await addressService.createAddress(rootState.currentAccountId, address);
      commit(ADD_ADDRESS, response.data.address);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: CREATE_ADDRESS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: CREATE_ADDRESS, error: e });
    }
  },

  /**
   * 
   * update address
   */
  async [UPDATE_ADDRESS]({ rootState, commit }, address) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_ADDRESS });
    try {
      const { data } = await addressService.updateAddress(rootState.currentAccountId, address);
      commit(REPLACE_ADDRESS, data.address);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_ADDRESS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_ADDRESS, error: e });
    }
  },

  /**
   * Delete address
   */
  async [DELETE_ADDRESS]({ rootState, commit, dispatch }, addressId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_ADDRESS });
    try {
      await addressService.deleteAddress(rootState.currentAccountId, addressId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_ADDRESS });
      dispatch(GET_ADDRESS);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_ADDRESS, error: e });
    }
  },
  async [GET_USER_VISIBLE_COLUMNS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USER_VISIBLE_COLUMNS });
    commit(SET_USER_VISIBLE_COLUMNS, []);
    try {
      var userVisibleColumns = map(filter(addressService.columnSettings, (col) => !col.hide), function(col) {
        return col.name || col.displayName;
      });
      commit(SET_USER_VISIBLE_COLUMNS, userVisibleColumns);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USER_VISIBLE_COLUMNS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USER_VISIBLE_COLUMNS, error: e });
    }
  },
};

export default actions;